import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createAndSaveFcmToken } from '../../Firebase/SendFcmToken';

const FcmTokenHandler = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    const userId = authState?.userId;
    const companyId = authState?.companyId;
    const url = authState?.apiUrl;

    if (!userId || companyId === undefined || companyId === null || !url) {
      return;
    }

    // 1. Initial check: If permission is already granted, ensure FCM device token is generated & saved
    if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
      createAndSaveFcmToken(authState, dispatch);
    }

    // 2. Dynamic permission change listener (detects when user manually updates browser settings)
    if (typeof navigator !== 'undefined' && 'permissions' in navigator && navigator.permissions.query) {
      let permissionStatusObj = null;

      navigator.permissions.query({ name: 'notifications' })
        .then((permissionStatus) => {
          permissionStatusObj = permissionStatus;
          const handlePermissionChange = () => {
            if (permissionStatus.state === 'granted') {
              createAndSaveFcmToken(authState, dispatch);
            }
          };

          permissionStatus.onchange = handlePermissionChange;
        })
        .catch((err) => {
          console.error("Error querying notification permission status:", err);
        });

      return () => {
        if (permissionStatusObj) {
          permissionStatusObj.onchange = null;
        }
      };
    }
  }, [authState?.userId, authState?.companyId, authState?.apiUrl, dispatch]);

  return null;
};

export default FcmTokenHandler;
